module.exports = __webpack_public_path__ + "img/MARCOPOLO.51053486.svg";